import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaPhone, FaEnvelope, FaMapMarkerAlt, FaHeart } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
        <div>
  <div className="flex items-center space-x-3 mb-4">
    <img 
      src="/Helen Keller Madurai Logo.jpg"
      alt="Helen Keller Society Logo" 
     className="h-16 w-16 object-contain"
    />
    <h2 className="text-xl font-bold">Helen Keller Service Society for the Disabled</h2>
  </div>
  <p className="text-gray-400 text-sm leading-relaxed">
    Empowering individuals with disabilities through inclusive programs, support services, and community engagement.
  </p>
</div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-secondary">Quick Links</h4>
            <ul className="space-y-2">
              <Link to="/" className="text-gray-400 hover:text-primary transition-colors block">
                Home
              </Link>
              <Link to="/about" className="text-gray-400 hover:text-primary transition-colors block">
                About Us
              </Link>
              <Link to="/services" className="text-gray-400 hover:text-primary transition-colors block">
                Services
              </Link>
              <Link to="/projects" className="text-gray-400 hover:text-primary transition-colors block">
                Projects
              </Link>
              <Link to="/donate" className="text-gray-400 hover:text-primary transition-colors block">
                Donate
              </Link>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-secondary">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-gray-400 text-sm">
                <FaMapMarkerAlt className="text-primary mt-1 flex-shrink-0" />
                <span>Vizhiyagam, Viswanathapuram,<br />Madurai - 625014<br />Tamil Nadu</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400 text-sm">
                <FaPhone className="text-primary flex-shrink-0" />
                <span>+91 94434 43513</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400 text-sm">
                <FaEnvelope className="text-primary flex-shrink-0" />
                <span>info@helenkellersociety.org</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-secondary">Follow Us</h4>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="bg-gray-800 hover:bg-primary p-3 rounded-full transition-all duration-300 transform hover:scale-110"
              >
                <FaFacebookF className="text-white" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-twitter"
                className="bg-gray-800 hover:bg-primary p-3 rounded-full transition-all duration-300 transform hover:scale-110"
              >
                <FaTwitter className="text-white" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="bg-gray-800 hover:bg-primary p-3 rounded-full transition-all duration-300 transform hover:scale-110"
              >
                <FaInstagram className="text-white" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-linkedin"
                className="bg-gray-800 hover:bg-primary p-3 rounded-full transition-all duration-300 transform hover:scale-110"
              >
                <FaLinkedinIn className="text-white" />
              </a>
            </div>
            <p className="text-gray-400 text-sm mt-6">
              Join our community and stay updated with our latest initiatives and events.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 Helen Keller Society for the Disabled. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Made with <span className="text-red-500">❤</span> for a more inclusive world
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;